<div *ngIf="type==='activities'">
  <div class="container">
  <p-toast position="top-center" style="background: none;"></p-toast> 
  <p-dialog
    [(visible)]="loading"
    [showHeader]="false"
    [resizable]="false"
    [modal]="true"
    [focusOnShow]="false"
    class="progress-overlay"
    style="background: none;"
  >
    <div style="width: 232px; height: 150; padding-top: 5%; background: none;" class="text-center">
      <!-- <h6 style="position:relative; top: -5px; background: none;">One moment while I generate your Deidentified report</h6> -->
      <p-progressSpinner
        [style]="{ width: '50px', height: '50px', background: 'none' }"
      ></p-progressSpinner>
    </div>
  </p-dialog>
  <!-- <div class="container"> -->
    <form action="" (ngSubmit)="sendEmail($event)" (keydown.enter)="blockInvalidEmailSubmit($event)" novalidate>
    <div class="row">
        <div class="col-6">
            <div class="form-group">
              <label for="exampleInputEmail1"> <b>Recipient emails</b> </label>
              <label style="font-size: 10px;font-weight: bold; height:20px">(Comma seperated)</label>
              <input
                type="email"
                multiple
                class="form-control"
                [class.is-invalid]="recipientEmailError"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                [(ngModel)]="toEmail"
                (ngModelChange)="onRecipientEmailsChange()"
                (blur)="markRecipientEmailsTouched()"
                name="toEmail"
              />
              <small *ngIf="recipientEmailError" class="text-danger font-weight-bold">{{recipientEmailError}}</small>
            </div>
           
            <div class="form-group">
              <label for="exampleInputEmail1"><b>Subject</b></label>
              <input type="text" required class="form-control" [(ngModel)]="subject" name="subject" />
            </div>
            <!-- <div class="form-group">
              <label for="exampleInputEmail1">Your email</label>
              <input
                type="email"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                [(ngModel)]="fromEmail"
              />
              
            </div> -->
           <div class="spacer"></div>
            <div class="form-group">
              <label for="exampleInputEmail1"><b>Include message(optional)</b></label>
              <textarea cols="30" rows="6" class="form-control" [(ngModel)]="message" name="message"></textarea>
            </div>

              <!-- <div class="form-group" *ngIf="sharableUrl!=null">
                <textarea readonly  cols="30" rows="2" class="form-control">{{sharableUrl}}</textarea>
              </div>
              <div class="float-right" *ngIf="type=='activities'">
                  <a tabindex="0" (click)="getActivityLink()" class="text-primary get-link" role="button">Get sharable link</a>
              </div> -->
            <div class="buttonCol">
              <div class="innerButton">
                <button type="button" (click)="cancel()" class="btn btn-danger">Cancel</button>
                <button type="submit" [disabled]="!canSendEmail" class="btn btn-primary">Send</button>
              </div>
            </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="exampleInputEmail1"><b>Message Body</b></label>
            <textarea readonly cols="30" rows="5" class="form-control" [(ngModel)]="body" name="body"></textarea>
          </div>
          <div class="form-group">
            <label for="exampleInputEmail1"><b>Canned Text</b></label>
            <textarea cols="30" rows="4" class="form-control" [(ngModel)]="cannedText" name="cannedText" style="font-size: 12px;font-weight: bold;"></textarea>
          </div>
          <div class="form-group">
            <label for="exampleInputEmail1"><b>Attachments</b></label>
            <!-- <div class="row"> -->
              <div class="row" *ngFor="let file of files">
                <div class="form-group" style="align-items: center;">
                  <a href="{{url}}{{file}}" target="_blank">{{parseFileName(file)}}</a>
                </div>
              </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </form>
  <!-- </div> -->
  </div>
</div>

<div *ngIf="type==='adminfollowup'">
  <div class="container">
    <p-toast position="top-center" style="background: none;"></p-toast> 
    <p-dialog
      [(visible)]="loading"
      [showHeader]="false"
      [resizable]="false"
      [modal]="true"
      [focusOnShow]="false"
      class="progress-overlay"
      style="background: none;"
    >
      <div style="width: 232px; height: 150; padding-top: 5%; background: none;" class="text-center">
        <!-- <h6 style="position:relative; top: -5px; background: none;">One moment while I generate your Deidentified report</h6> -->
        <p-progressSpinner
          [style]="{ width: '50px', height: '50px', background: 'none' }"
        ></p-progressSpinner>
      </div>
    </p-dialog>

    <form action="" (ngSubmit)="sendEmail($event)" (keydown.enter)="blockInvalidEmailSubmit($event)" novalidate>
      <div class="row">
          <div class="col-6">
              <div class="form-group">
                <label for="exampleInputEmail1"> <b>Recipient emails</b> </label>
                <label style="font-size: 10px;font-weight: bold; height:20px">(Comma seperated)</label>
                <input
                  type="email"
                  multiple
                  class="form-control"
                  [class.is-invalid]="recipientEmailError"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                  [(ngModel)]="toEmail"
                  (ngModelChange)="onRecipientEmailsChange()"
                  (blur)="markRecipientEmailsTouched()"
                  name="toEmail"
                />
                <small *ngIf="recipientEmailError" class="text-danger font-weight-bold">{{recipientEmailError}}</small>
              </div>
             
              <div class="form-group">
                <label for="exampleInputEmail1"><b>Subject</b></label>
                <input type="text" required class="form-control" [(ngModel)]="subject" name="subject" />
              </div>
              <!-- <div class="form-group">
                <label for="exampleInputEmail1">Your email</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                  [(ngModel)]="fromEmail"
                />
                
              </div> -->
             <div class="spacer"></div>
              <div class="form-group">
                <label for="exampleInputEmail1"><b>Include message(optional)</b></label>
                <textarea cols="30" rows="6" class="form-control" [(ngModel)]="message" name="message"></textarea>
              </div>
  
                <!-- <div class="form-group" *ngIf="sharableUrl!=null">
                  <textarea readonly  cols="30" rows="2" class="form-control">{{sharableUrl}}</textarea>
                </div>
                <div class="float-right" *ngIf="type=='activities'">
                    <a tabindex="0" (click)="getActivityLink()" class="text-primary get-link" role="button">Get sharable link</a>
                </div> -->
              <div class="buttonCol">
                <div class="innerButton">
                  <button type="button" (click)="cancel()" class="btn btn-danger">Cancel</button>
                  <button type="submit" [disabled]="!canSendEmail" class="btn btn-primary">Send</button>
                </div>
              </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="exampleInputEmail1"><b>Message Body</b></label>
              <textarea readonly cols="30" rows="5" class="form-control" [(ngModel)]="body" name="body"></textarea>
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1"><b>Canned Text</b></label>
              <textarea cols="30" rows="4" class="form-control" [(ngModel)]="cannedText" name="cannedText" style="font-size: 12px;font-weight: bold;"></textarea>
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1"><b>Attachments</b></label>

                <div class="row" *ngFor="let file of files">
                  <div class="form-group" style="align-items: center;">
                    <a href="{{url}}{{file}}" target="_blank">{{parseFileName(file)}}</a>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </form>

    </div>
  
</div>
